/**
 * This file is auto-generated from GenderInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const genderLabel: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Gender';
        case 'pl':
            return 'Płeć';
    }
};
